// extracted by mini-css-extract-plugin
module.exports = {"news-item-box":"R","newsItemBox":"R","img-box":"S","imgBox":"S","img-mask-box":"T","imgMaskBox":"T"};